import { render, staticRenderFns } from "./upimg.vue?vue&type=template&id=6011154e"
import script from "./upimg.vue?vue&type=script&lang=js"
export * from "./upimg.vue?vue&type=script&lang=js"
import style0 from "./upimg.vue?vue&type=style&index=0&id=6011154e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports